import { ModelSagres } from "@/types/model-sagres";

export class ContatosResponsavel extends ModelSagres {
    Id: number
    Cpf: string
    Nome: string
    Fone: string
    Email: string
    idUnidadeOrcamentaria: number

    constructor(obj?: any) {
        super();
        if (obj) {
            this.Id = obj.Id;
            this.Cpf = obj.Cpf ?? '';
            this.Nome = obj.Nome ?? '';
            this.Fone = obj.Fone ?? '';
            this.Email = obj.Email ?? '';
            this.idUnidadeOrcamentaria = obj.idUnidadeOrcamentaria;
        }
    }
}